import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import JoinInvite from "@/pages/JoinInvite";
import AdminDashboard from "@/pages/AdminDashboard";
import SupporterDashboard from "@/pages/SupporterDashboard";
import VolunteerPortal from "@/pages/VolunteerPortal";
import { homePath } from "@/lib/roles";

function FullLoader() {
  return (
    <div className="grid min-h-screen place-items-center bg-[#f8f3e9]">
      <div className="h-10 w-10 animate-spin rounded-full border-4 border-[#e4d8c4] border-t-[#65949c]" />
    </div>
  );
}

function Protected({ role, allow, children }) {
  const { user, ready } = useAuth();
  const location = useLocation();
  if (!ready) return <FullLoader />;
  if (!user) return <Navigate to="/login" replace state={{ from: location }} />;
  if (allow) {
    if (!allow(user)) return <Navigate to={homePath(user)} replace />;
    return children;
  }
  if (role && user.role !== role) {
    return <Navigate to={homePath(user)} replace />;
  }
  return children;
}

function AppRoutes() {
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/login" element={<Login />} />
      <Route path="/join/:token" element={<JoinInvite />} />
      <Route
        path="/admin"
        element={
          <Protected role="admin">
            <AdminDashboard />
          </Protected>
        }
      />
      <Route
        path="/portal"
        element={
          <Protected role="supporter">
            <SupporterDashboard />
          </Protected>
        }
      />
      <Route
        path="/volunteer"
        element={
          <Protected allow={(u) => u.role === "admin" || !!u.volunteer_role}>
            <VolunteerPortal />
          </Protected>
        }
      />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  useEffect(() => {
    document.title = "Hope Floats · LSSP x Hope Floats Foundation";
  }, []);
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <AppRoutes />
          <Toaster position="top-center" richColors />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
